import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Icon from 'components/common/Icon/Icon'
import { generateTitleBasedOnQuantity } from './helpers'

const AddedItemsToCart = ({
  nrOfItemsAddedToCart,
  urlLinkToViewCart,
  handleViewCartClick,
  className
}) =>
  <Wrapper
    className={ className }
    data-at-garage-vehicle-viewcart
    to={ urlLinkToViewCart }
    onClick={ handleViewCartClick }>
    <CartIcon asset="cart-red" />
    <CartItemsQuantity >
      { `(${nrOfItemsAddedToCart} ${generateTitleBasedOnQuantity(nrOfItemsAddedToCart)})` }
    </CartItemsQuantity>
  </Wrapper>

AddedItemsToCart.propTypes = {
  className: PropTypes.string,
  handleViewCartClick: PropTypes.func,
  nrOfItemsAddedToCart: PropTypes.number,
  urlLinkToViewCart: PropTypes.string
}

export default AddedItemsToCart

export const Wrapper = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    text-decoration: none;
  }
`

export const CartIcon = styled(Icon)`
  width: 19px;
  height: 17px;
  margin-right: 10px;
`

export const CartItemsQuantity = styled.div`
  ${Mixin.font.GothamBold(14, 600, 17)}
  color: ${Theme.colors.bright_red_new};
`
